
import {
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubItem,
} from "@/components/ui/sidebar"
import Translatable from "../translatable_text/Translatable";
import { Link, useLocation, useNavigate } from "react-router-dom";

type Props = {
  href: string;
  title: string;
  Icon: React.ElementType;
  children?: Array<any>;
}
export default function SidebarItem({title, Icon, href, children}: Props) {
  const route = useNavigate()
  const location = useLocation();
  const pathname = location.pathname
  

  const isActive = (pathname === '/' && href === '/') ||
    pathname === href ||
    pathname?.startsWith(`${href}/`)
  ;

  return (
    <SidebarMenuItem>
      <SidebarMenuButton className="hover:bg-[#9877c4]/20 cursor-pointer" asChild>
        <div
          className={
            isActive
              ? "bg-[#ffffff] hover:bg-[#ebebeb] text-white no-underline"
              : "hover:bg-[#c5b3dc]/20"
          }
          onClick={()=> route(href)}
        >
          <Icon className={isActive ? "text-purple" : "text-white"}/>
          <span className={`${isActive ? "text-purple" : 'text-white'}`}
          ><Translatable>{title}</Translatable></span>
        </div>
      </SidebarMenuButton>
      <SidebarMenuSub>
        {children && (
          <div className="flex flex-col">
            {children?.map((sub) => (
              <SidebarMenuSubItem key={sub.title}>
                <SidebarMenuButton
                  className="hover:bg-gray-200"
                  asChild
                >
                  <Link
                    className={
                      isActive
                        ? "bg-gray-200 hover:bg-gray-300"
                        : "hover:bg-gray-100"
                    }
                    to={sub.href}
                  >
                    <sub.icon />
                    {sub.title}
                  </Link>
                </SidebarMenuButton>
              </SidebarMenuSubItem>
            ))}
          </div>
        )}
      </SidebarMenuSub>
    </SidebarMenuItem>
  )
}
